import React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import NtkHeader from "../common/NtkHeader";
import NtkParagraph from "../common/NtkParagraph";

const useStyles = makeStyles((theme) => ({
  containerGrid: {
    margin: "1.5em auto ",
    backgroundColor: "#F6F6F6",
    justifyContent: "center",
    paddingBottom: "10em",
    paddingTop: "5em",
  },
}));
const WhyNatakallam = () => {
  const classes = useStyles();
  return (
    <Grid className={classes.containerGrid}>
      <Grid container>
        <NtkHeader header="Why NaTakallam?" />
        <NtkParagraph
          paragraph="NaTakallam is an award winning social enterprise on a mission to change the way your learn a language,
and support refugee livelihoods. "
        />
      </Grid>
    </Grid>
  );
};

export default WhyNatakallam;
